"use client";

import { Action } from "./parts";
import { Sheet } from "./Sheet";

/*
 * 로그인 유도 시트 — 시안 02 (`docs/design/simple-skin/sample/02-login-gate-mo.html`).
 *
 * 🔴 **손님이 «구매하기» 를 누르면 화면을 옮기지 않고 이 시트가 뜹니다.** 고른 상품권·수량은
 *    `next` 주소(`/?product=…&qty=…`)에, 적어 둔 번호는 구매 화면이 세션 저장소에 들고 있어서
 *    로그인·가입을 마치면 **하던 자리로 돌아옵니다**(README §5 «덮개는 이동이 아니다»).
 * 🔑 문구는 시안 그대로 한 줄 — 왜 로그인이 필요한지(핀번호가 계정에 남는다)만 말합니다.
 */
export function LoginGateSheet({ open, onClose, next }: { open: boolean; onClose: () => void; next: string }) {
  const q = `?next=${encodeURIComponent(next)}`;
  return (
    <Sheet
      open={open}
      onClose={onClose}
      title={<span className="text-[length:calc(var(--tnf-text-base)*20/14)]">로그인이 필요합니다</span>}
      footer={
        <div className="grid gap-[9px]">
          <Action href={`/login${q}`} tooltip="로그인하고 이 구매 화면으로 돌아옵니다.">로그인</Action>
          <Action href={`/register${q}`} variant="secondary" tooltip="회원 가입을 마치고 이 구매 화면으로 돌아옵니다.">회원 가입</Action>
        </div>
      }
    >
      <p className="text-[length:calc(var(--tnf-text-base)*14.5/14)] leading-[1.65] text-ink-soft">핀번호는 계정에 저장됩니다.</p>
    </Sheet>
  );
}
